// Modules
import cn from 'classnames';

// Types
import type { TModalBodyProps } from './Modal.type';

// Styles
import styles from './styles.module.scss';

const ModalBody = (props: TModalBodyProps) => {
  const {
    children,
    className,
    ...restProps
  } = props;

  const modalBodyCN = cn(styles.legion_modal_body, className);

  return (
    <div className={modalBodyCN} {...restProps}>
      {children}
    </div>
  );
};

export default ModalBody;
